import axios from '@/util/basehttp';
import encrypAxios from '@/util/encryphttp';
import qs from 'qs';

const sysLogin = {
  // post提交
  passWordLogin(params) {
    return encrypAxios.post(`/passWordLogin`, params);
  },
  smsCodeLogin(params) {
    return encrypAxios.post(`/smsCodeLogin`, params);
  },
  updatePassWord(params) {
    return encrypAxios.post(`/updatePassWord`, params);
  },
  sendCodeSms(phone) {
    return axios.post(`/sendCodeSms`, qs.stringify({phone: phone}));
  },
  logout() {
    return axios.get(`/logout`);
  },
  getWebUserInfo() {
    return axios.get(`/getWebUserInfo`);
  },

  publicKey() {
    return axios.get(`/publicKey`);
  }
}
export default sysLogin;



// WEBPACK FOOTER //
// ./src/api/sys/login.js